import { createSlice } from "@reduxjs/toolkit";

// localStorage에서 초기값 불러오기
const loadAuthState = () => {
  try {
    const serialized = localStorage.getItem("auth")
    if (!serialized) return { user: null, token: null, isAuthenticated: false }
    return JSON.parse(serialized)
  } catch (e) {
    console.warn("Auth load error:", e)
    return { user: null, token: null, isAuthenticated: false }
  }
}

// localStorage에 저장하는 헬퍼
const saveAuthState = (state) => {
  try {
    const serialized = JSON.stringify(state)
    localStorage.setItem("auth", serialized)
  } catch (e) {
    console.warn("Auth save error:", e)
  }
}

// 초기 state를 localStorage에서 읽어서 세팅
const initialState = loadAuthState()
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      // action.payload: { user, access_token }
      state.user            = action.payload.user
      state.token           = action.payload.access_token
      state.isAuthenticated = true

      // localStorage에 저장
      saveAuthState({
        user: state.user,
        token: state.token,
        isAuthenticated: true
      })
    },
    logout: (state) => {
      state.user            = null
      state.token           = null
      state.isAuthenticated = false

      // localStorage에서 제거
      localStorage.removeItem("auth")
    },
    setToken: (state, action) => {
      // action.payload: { access_token }
      state.token = action.payload
      saveAuthState({ ...state })
    }
  },
})

export const { login, logout, setToken } = authSlice.actions
export default authSlice.reducer